export default "__VITE_ASSET__CuErwmb0__"